import { render, staticRenderFns } from "./GroupSiteConfirmModal.vue?vue&type=template&id=12dc2106&"
import script from "./GroupSiteConfirmModal.vue?vue&type=script&lang=js&"
export * from "./GroupSiteConfirmModal.vue?vue&type=script&lang=js&"
import style0 from "./GroupSiteConfirmModal.vue?vue&type=style&index=0&id=12dc2106&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports